import request from "@/utils/request";
import qs from "qs";

/**
 * 新增-编辑地区
 * @param params
 * @returns {*}
 */
export function editRegion(params) {
  return request.post("/region/editRegion", qs.stringify(params));
}

/**
 * 查询地区树 【数据量太大，会蹦，所以不使用】
 * @param params
 * @returns {*}
 */
export function getRegionTree(params) {
  return request({
    url: "/region/getRegionTree",
    method: "get",
    params
  });
}

/**
 * 查询级联地区
 * @param params
 * @returns {*}
 */
export function getCascadeRegion(params) {
  return request({
    url: "/region/getCascadeRegion",
    method: "get",
    params
  });
}
